var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Nav'),_c('div',{staticStyle:{"margin-top":"100px"}},[_vm._v(" "+_vm._s(_vm.wallet.total_amount)+" Rs ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }